const countDecimals = value => {
	if (value.toString().includes('.')) {
		return value.toString().split('.')[1].length || 0;
	}
	return 0;
};

const someFunction = () => {
	return true;
};

export { countDecimals, someFunction };
